import { BehaviorSubject } from 'rxjs';
import * as i0 from "@angular/core";
export class UserService {
    constructor() {
        this._userInfo = new BehaviorSubject({
            nombre_usuario: null,
            organo: null,
            rol: null,
        });
        this.userInfo$ = this._userInfo.asObservable();
    }
    setUserInfo(parcial) {
        const actual = this._userInfo.value;
        const actualizado = Object.assign({}, actual, parcial);
        this._userInfo.next(actualizado);
    }
    getUserInfo() {
        return this._userInfo.getValue();
    }
}
UserService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function UserService_Factory() { return new UserService(); }, token: UserService, providedIn: "root" });
